import ClearingAPI from '@shared/api';

export const {
    positions: { getMyPortfolioAsync },
} = ClearingAPI.settings;
